import { DeploymentStatus } from "../../pipelines/validations"
import { CopyIcon } from "../../core/components/CopyIcon"
import Button from "@mui/material/Button"
import React from "react"
import { Deployment } from "@prisma/client"

export interface FailReasonProps {
  deployment: Deployment
}

export default function FailReason(props: FailReasonProps) {
  const { deployment } = props

  if (deployment.status !== DeploymentStatus.FAILED) {
    return null
  }

  if (!deployment.failReason) {
    return <span>N/A</span>
  }

  function handleClipboardCopy() {
    if (!navigator.clipboard || !deployment.failReason) {
      return
    }

    const formatted = deployment.failReason.replace(/;/g, "\n")

    void navigator.clipboard.writeText(formatted)
  }

  return (
    <span>
      <span>Missing translations</span>
      <Button
        style={{ border: "none", padding: "5px 5px 5px 9px" }}
        variant="outlined"
        color="primary"
        startIcon={<CopyIcon />}
        onClick={handleClipboardCopy}
      >
        Copy
      </Button>
    </span>
  )
}
